export const no = {
  message: {
    layout: {
      login: 'Logg inn',
      logout: 'Logg ut',
      dashboard: 'Dashboard',
      stampTime: 'Stempling',
      projects: 'Prosjekter',
      hourlogging: 'Timeføring',
      approval: 'Godkjenning',
      reports: 'Rapporter',
      settings: 'Innstillinger',
      user: 'Bruker',
      activities: 'Aktiviteter',
      members: 'Medlemmer',
      worktypes: 'Arbeidstype',
      holidays: 'Ferier',
      companySettings: 'Bedriftsinnstillinger',
      sharepointSettings: 'Sharepoint Settings',
      project: 'Project',
      company: 'Company',
      customerLogin: 'Customer login'
    },
    dashboard: {
      hoursDetails: 'Totalt antall timer',
      employeeDetails: 'Timer per medarbeider', // 'Per ansatt',
      dayDetails: 'Timer per dag', // 'Per dag',
      userHours: 'Timelogg Detaljer',
      hourState: 'Timer stat',
      overviewHours: 'Oversikt timer'
    },
    login: {
      language: 'Spårk',
      back: 'Tilbake',
      userName: 'Brukernavn',
      password: 'Brukerpassord',
      authFailed: 'Godkjenning mislyktes !',
      enterUserName: 'Skriv inn brukernavn',
      enterPassword: 'Skriv inn passord',
      enterConfirmPassword: 'Gjenta passord',
      resetNow: 'Nullstill',
      invalidPassword: 'Ugyldig passord',
      unauthorizedMsg: 'Ingen tillatelse!',
      error: 'Feil',
      contactAdmin: 'Kontakt administrator',
      retry: 'Prøv på nytt',
      redirectToSo: 'Vent mens vi viderekobler til SuperOffice'
    },
    common: {
      translate: 'Oversette',
      required: 'Kreves',
      refresh: 'Forfriske',
      name: 'Navn',
      english: 'Engelsk',
      norwegian: 'Norsk',
      save: 'Lagre',
      send: 'Send',
      edit: 'Endre',
      cancel: 'Avbryt',
      update: 'Oppdater',
      delete: 'Slett',
      updateAndClose: 'Oppdater og lukk',
      close: 'Lukk',
      new: 'Ny',
      isActive: 'Er aktiv',
      isDefault: 'Er standard',
      addNew: 'Legg til ny',
      savedSuccess: 'Lagret',
      addedSucess: 'Opprettet',
      updatedSuccess: 'Oppdatert',
      deleteSuccess: 'Slettet',
      backToList: 'Tilbake til listen',
      search: 'Søk',
      yes: 'Ja',
      no: 'Nei',
      deleteMsg: 'Slettet',
      loadingMsg: 'Laster inn, vennligst vent',
      deleteConfirm: 'Bekreft sletting',
      areYouSure: 'Er du sikker på at du vil slette?',
      includeAttachment: 'Vil du inkludere documenter i rapport?',
      validationIssue: 'Vennligst sjekk de obligatoriske feltene!',
      noResults: 'Ingen resultater funnet!',
      noRecords: 'Ingenting funnet!',
      position: 'Posisjon',
      changedPassword: 'Passord endret',
      invalidEmail: 'Ugyldig e-post',
      invalidNumber: 'Ugyldig nummer',
      ok: 'Ok',
      date: 'Dato',
      comments: 'Kommentarer',
      status: 'Status',
      description: 'Beskrivelse',
      others: 'Andre',
      total: 'Total',
      actions: 'Handlinger',
      color: 'Farge',
      year: 'År',
      month: 'Måned',
      responsible: 'Ansvarlig',
      attachments: 'Vedlegg',
      low: 'Lav',
      medium: 'Medium',
      high: 'Høy',
      download: 'Nedlasting',
      details: 'Detaljer',
      report: 'Rapportere',
      updatedOn: 'Oppdatert på',
      confirmation: 'Bekreftelse',
      startDate: 'Start Dato',
      endDate: 'Slutt Dato',
      clear: 'Tøm',
      email: 'E-post',
      all: 'Alle',
      state: 'Status',
      addWorkType: 'Legg til arbeidstype',
      updateWorkType: 'Oppdater arbeidstype',
      addHoliday: 'Legg til ferie',
      updateHoliday: 'Oppdater ferie',
      addProject: 'Legg til prosjekt',
      updateProject: 'Oppdater prosjekt',
      addActivity: 'Legg til aktivitet',
      updateActivity: 'Oppdater aktivitet',
      task: 'Oppgave',
      cost: 'Timepris', /* Kost */
      number: 'Antall',
      sync: 'Synk',
      image: 'Bilde',
      estimatedHours: 'Estimerte timer',
      receivedPayment: 'Mottatt betaling',
      employee: 'Ansatt',
      syncStarted: 'Synkroniseringen starter!',
      type: 'Type',
      select: 'Velg',
      weekTotalHours: 'Uke timer',
      logoutSuccess: 'Du er logget av!',
      selectUsers: 'Velg brukere',
      approvalHours: 'Godkjenning timer',
      newUpdate: 'Ny oppdatering tilgjengelig!',
      weekNotExists: 'Uke eksisterer ikke',
      invalidHours: 'Ugyldig timer',
      canDeliverHours: 'Levere timer',
      active: 'Aktiv',
      completed: 'Completed',
      logoImage: 'Logobilde',
      uploadedSuccess: 'Uploaded successfully !',
      hoursDetails: 'Hour Details'
    },
    timer: {
      start: 'Start',
      stop: 'Stopp',
      pause: 'Pause',
      resume: 'Gjenoppta',
      selectProjects: 'Velg prosjekt',
      selectEmployees: 'Velg ansatt',
      go: 'Søk',
      approveHours: 'Godkjenn Timer',
      approvedHours: 'Godkjente Timer',
      notApprovedHours: 'Ikke Godkjente Timer',
      approve: 'Godkjenn',
      notApprove: 'Ikke godkjent',
      addHours: 'Legg til timer',
      notApproved: 'Ikke godkjent kommentarer',
      amount: 'Antall',
      selectEntries: 'Utvalgte',
      deliver: 'Levere',
      totalHours: 'Total timer',
      timer: 'Timer',
      hours: 'Timer',
      editHours: 'Rediger timer',
      deliveredSuccessfully: 'Innlevert!',
      noHours: 'Ingen timer',
      approved: 'Godkjent',
      notApprovedMsg: 'Ikke godkjent',
      delivered: 'Levert',
      notDelivered: 'Ikke levert',
      workType: 'Arbeidstype',
      finder: 'Finder',
      findersFee: 'Finder\'s fee'
    },
    reports: {
      perProject: 'Per prosjekt',
      perActivity: 'Per aktivitet',
      perEmployee: 'Per ansatt',
      filterActions: 'Filtrer handlinger',
      selectProject: 'Velg prosjekt',
      selectEmployees: 'Velg ansatte',
      runReport: 'Kjør rapport',
      onlySum: 'Bare sum',
      showEstimation: 'Vis estimering',
      sendReport: 'Send rapport',
      emailNote: 'Bruk komma (,) for å legge til flere e-post adresser',
      emailValidation: 'E-postmeldingen må være gyldig',
      fileType: 'Filtype',
      onlyXlsx: 'Bare xslx',
      onlyPdf: 'Bare PDF',
      both: 'Begge',
      sentSuccess: 'Rapporter vellykket sendt',
      includeDependent: 'Inkluder datter',
      salesPrice: 'Salgspris',
      totalSalesPrice: 'Total salgspris',
      totalCostPrice: 'Total kostpris',
      from: 'Fra',
      till: 'Til',
      consumptionSalt: 'Forbruk salt',
      hourSalting: 'Antall timer salting',
      hourPlowing: 'Antall timer brøyt',
      timesSalting: 'Antall ganger salting',
      timesPlowing: 'Antall ganger brøyt',
      saltQuantity: 'Mengde salt',
      mgQuantity: 'Mengde MG',
      amountT: 'Antall t',
      totalSaltingPeriod: 'Tot timersalting valgt periode',
      totalPlowingPeriod: 'Tot timer brøyt valgt periode',
      totalQtySaltingPeriod: 'Tot antall salting valgt periode',
      totalQtyPlowingPeriod: 'Tot antall brøyting valgt periode',
      totalSaltSelected: 'Total mengde salt valgt periode',
      totalMGSelected: 'Total mengde MG valgt periode',
      total: 'Timer totalt', /* Total */
      estimation: 'Estimerte timer', /* Estimerte */
      progress: 'Fremdrift timer', /* Fremdrift */
      userCost: 'Internkostnad' /* Ansatt kost */,
      cost: 'Påløpt salær', // show this when show only estimation is selected,
      allEmployeesProjectHours: 'Totalt antall timer prosjekt',
      totalProjectHours: 'Totalt antall timer i prosjekt',
      receivedPaymentProgress: 'Innbetalt salær i % av a-konto'
    },
    stamp: {
      project: 'Prosjekt',
      activity: 'Aktivitet'
    },
    sharepointSettings: {
      config: 'SharePoint Configurations',
      credential: 'SharePoint Credentials',
      baseUrl: 'Domene',
      siteUrl: 'Side url',
      listName: 'Liste navn',
      loadFolders: 'Last inn mapper',
      loadList: 'Last inn lister',
      propertiesConfig: 'Egenskaper konfigurasjon',
      contentType: 'Innholdstype',
      companyRootFolder: 'Select Company Folder',
      projectRootFolder: 'Select Project Folder'
    },
    hse: {
      hseSystem: 'HSE-SYSTEM',
      uploadDocument: 'Upload Document',
      gettingFolders: 'Loading... Please wait...',
      noDocuments: 'NO DOCUMENTS FOUND!',
      noFolders: 'NO FOLDERS FOUND!',
      createNew: 'Create',
      editName: 'Edit folder',
      deleteFolder: 'Delete folder',
      upload: 'Upload',
      folderName: 'Folder name',
      files: 'Files',
      noResponsible: '*no responsible',
      noDescription: '*no description',
      updateMetaData: 'Update Meta Data',
      openNewTab: 'Open in new Tab',
      editMeta: 'Edit Meta',
      rename: 'Rename',
      versionHistory: 'Version History',
      versionLabel: 'Version Label',
      size: 'Size',
      modifiedBy: 'Modified By',
      modifiedOn: 'Modified On',
      title: 'Title',
      searchFound: 'Search Results : Found',
      createdSuccess: 'Created successfully!',
      renameSuccess: 'Renamed successfully!'
    }
  }
}
